<template>
    <div v-if="lang" class="estate-card-user-buttons">
        <img
            v-if="showHide"
            :src="'/img/icons/hidden' + (this.is_hidden ? '-active' : '') + '.svg'"
            :alt="trans('labels.hide')"
            @click.prevent="onHideClick"
            width="24"
            height="20"
        >

        <img
            v-if="showSave"
            :src="'/img/icons/' + network + '/favorite' + (this.is_saved ? '-active' : '') + '.svg'"
            :alt="trans('labels.save')"
            @click.prevent="onSaveClick"
            width="24"
            height="20"
        >
    </div>
</template>

<script>
export default {
    props: {
        estate: {
            type: Object,
            required: true,
        },

        extLang: {
            type: Object
        },

        showHide: {
            type: Boolean,
            default: true,
        },

        showSave: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            is_hidden: this.estate.is_hidden,
            is_saved: this.estate.is_saved,
        }
    },

    computed: {
        lang() {
            if(this.extLang == undefined)
                return this.$root.lang.estate_card
            else
                return this.extLang
        },

        network() {
            return window.network
        }
    },

    methods: {
        onHideClick() {
            window.events.$emit('prevent_card_click')

            if(this.is_logged_in()) {
                isLoading()

                let method = this.is_hidden ? 'delete' : 'post'

                let params = {
                    type: this.estate.ad_type,
                    id: this.estate.id,
                    agency: this.estate.agency.id,
                }

                if (method == 'delete') {
                    params = {data: params}
                }

                axios[method]('/api/hidden-estates', params)
                    .then(({data}) => {
                        stopLoading()

                        this.is_hidden = ! this.is_hidden

                        this.$emit('hide')
                    })
            }
            else {
                window.events.$on('login_completed', () => {
                    this.onHideClick()
                })

                window.events.$emit('showModal', { name: 'login', data: { action: true }})
            }
        },

        onSaveClick() {
            window.events.$emit('prevent_card_click')

            if (this.is_logged_in()) {
                isLoading()

                let method = this.is_saved ? 'delete' : 'post'

                let params = {
                    type: this.estate.ad_type,
                    id: this.estate.id,
                    agency: this.estate.agency.id,
                }

                if (method == 'delete') {
                    params = {data: params}
                }

                axios[method]('/api/saved-estates', params)
                    .then(({data}) => {
                        stopLoading()

                        this.is_saved = ! this.is_saved

                        if(! this.is_saved) {
                            this.$emit('unsaved')
                        }
                    })
            }
            else {
                window.events.$on('login_completed', () => {
                    this.onSaveClick()
                })

                window.events.$emit('showModal', { name: 'login', data: { action: true }})
            }
        },
    },
}
</script>